import { useEffect } from 'react';

interface SEOProps {
    title?: string;
    description?: string;
    image?: string;
    url?: string;
    type?: string;
    noindex?: boolean;
}

export function useSEO({ title, description, image, url, type = 'website', noindex = false }: SEOProps) {
    useEffect(() => {
        // 1. Basic Meta
        if (title) {
            document.title = `${title} | Akademia Milionerów`;
        }

        const updateMeta = (name: string, content: string, attr: 'name' | 'property' = 'name') => {
            let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement;
            if (!el) {
                el = document.createElement('meta');
                el.setAttribute(attr, name);
                document.head.appendChild(el);
            }
            el.content = content;
        };

        if (description) {
            updateMeta('description', description);
        }

        if (noindex) {
            updateMeta('robots', 'noindex, nofollow');
        } else {
            updateMeta('robots', 'index, follow');
        }

        // 2. OpenGraph (Facebook)
        updateMeta('og:type', type, 'property');
        if (title) updateMeta('og:title', title, 'property');
        if (description) updateMeta('og:description', description, 'property');
        if (image) updateMeta('og:image', image, 'property');
        if (url) updateMeta('og:url', url, 'property');

        // 3. Twitter
        updateMeta('twitter:card', 'summary_large_image');
        if (title) updateMeta('twitter:title', title);
        if (description) updateMeta('twitter:description', description);
        if (image) updateMeta('twitter:image', image);

        // No explicit cleanup needed if other pages also use the hook, 
        // but we can reset to global defaults if desired.
    }, [title, description, image, url, type, noindex]);
}
